import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-qe',
    templateUrl: './page-qe.component.html',
    styleUrls: ['./page-qe.component.css'],
    standalone: false
})
export class PageQeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
